//For use on all static text unless otherwise specified
export const PRIMARY_TEXT = "rgba(90, 88, 94, 1)"

//Secondary Text Color, also Inactive Text color when text is on a background color.
export const SECONDARY_TEXT = "rgba(90, 88, 94, .6)"

//Active Text, also link/highlighted color, this is the neon blue.
export const ACTIVE_TEXT = "rgba(96, 121, 242, 1)"

//Selected Text, this is our darker purple, and the only purple to be used on top of a Background Color.
export const SELECTED_TEXT = "rgba(39, 61, 169, 1)"

//Our lightest grey, avoid using on text. Primarily used for drop shadows.
export const TINY_SHADOW = "rgba(90, 88, 94, 0.3)"

// Our background color generally denotes pages behind a login/user focused pages.
export const TINY_BKG = "rgba(242, 242, 247, 1)"

//Accents to be used sparingly, generally try not to use or check with Aeryk.
export const TINY_PINK = "rgba(250, 181, 235, 1)"

//Used in Warnings + Bans.
export const TINY_RED = "#FC8C9C"



// WEBPACK FOOTER //
// ./src/components/consts/colors.js